export const IconApplyAttach20: {
  name: 'icon_apply_attach_20-f16f79151f52'
} = {
  name: 'icon_apply_attach_20-f16f79151f52'
}
